import React, {FC, CSSProperties} from "react";
import {Typography} from "@material-ui/core";
import CommentIcon from "@material-ui/icons/Comment";

const styles: Record<string, CSSProperties> = {
  container: {
    marginTop: "16px",
    cursor: "pointer",
    border: "1px solid",
    borderRadius: "4px",
    padding: "12px",
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  commentIcon: {
    fontSize: "20px",
    marginTop: "2px",
  },
  text: {
    fontSize: "0.9rem",
    fontStyle: "italic",
  },
  content: {
    flex: 1,
  },
};

const variants = {
  deletion: {
    selected: {
      container: {
        backgroundColor: "#ffd6d6",
        borderColor: "#ffb4b4",
      },
      color: {color: "#d32f2f"},
    },
    unselected: {
      container: {
        backgroundColor: "#ffebee",
        borderColor: "#ffcdd2",
      },
      color: {color: "#ef9a9a"},
    },
  },
  addition: {
    selected: {
      container: {
        backgroundColor: "#c8e6c9",
        borderColor: "#a5d6a7",
      },
      color: {color: "#2e7d32"},
    },
    unselected: {
      container: {
        backgroundColor: "#e8f5e9",
        borderColor: "#c8e6c9",
      },
      color: {color: "#a5d6a7"},
    },
  },
  modification: {
    selected: {
      container: {
        backgroundColor: "#bbdefb",
        borderColor: "#90caf9",
      },
      color: {color: "#1976d2"},
    },
    unselected: {
      container: {
        backgroundColor: "#e3f2fd",
        borderColor: "#bbdefb",
      },
      color: {color: "#90caf9"},
    },
  },
};

interface ClauseChangeCommentProps {
  text: string;
  type: "deletion" | "addition" | "modification";
  isSelected: boolean;
  isDisabled?: boolean;
  isClauseSelected: boolean;
  onToggle: () => void;
}

const ClauseChangeComment: FC<ClauseChangeCommentProps> = ({
  text,
  type,
  isSelected,
  isDisabled,
  isClauseSelected,
  onToggle,
}) => {
  const variant = variants[type][isSelected ? "selected" : "unselected"];
  const isInteractive = !isDisabled && isClauseSelected;

  return (
    <div
      onClick={() => isInteractive && onToggle()}
      style={{
        ...styles.container,
        ...variant.container,
        opacity: isDisabled ? 0.85 : 1,
        cursor: isInteractive ? "pointer" : "default",
      }}
    >
      <CommentIcon
        style={{
          ...styles.commentIcon,
          ...variant.color,
        }}
      />
      <div style={styles.content}>
        <Typography
          style={{
            ...styles.text,
            ...variant.color,
          }}
        >
          {text}
        </Typography>
      </div>
    </div>
  );
};

export default ClauseChangeComment;
